import React from "react";
import { useNavigate } from "react-router-dom";
import MSISplashAltPage from "./MSISplashAltPage";

/**
 * Route wrapper: provides onEnter navigation to /auth for the alternate splash page.
 */
export default function MSISplashAltRoute() {
  const navigate = useNavigate();
  return (
    <MSISplashAltPage
      onEnter={() => navigate("/auth", { replace: true })}
    />
  );
}
